export default __webpack_public_path__ + "static/media/mobile-background.6e30409c.svg";